import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import TrainerMemberFilters from "./TrainerMemberFilters";
import { selectAuth } from "../auth/auth.selector";
import TrainerMemberTable from "./TrainerMemberTable";

const TrainerMember = ({ cardName, prevAllFilters, isGTPTreports }) => {
  const userInfo = useSelector(selectAuth);
  const { user } = userInfo || {};

  const isAdmin = user?.account_type === "admin";
  const isGym = user?.account_type === "gym";

  const [isPage, setIsPage] = useState(0);
  const iniAllFilters = {
    lastCheckedIn: "",
    selectedTrainer: "",
    selectedGym: prevAllFilters
      ? prevAllFilters.selectedGym
      : !isAdmin
      ? {
          label: isGym ? user?.name : user?.gym_name || "",
          value: user?.gym_id || user?.uid || user?.user_id || "",
        }
      : "",
    selectedTrainerLastCheckinSorting: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilters);
  const iniFilters = {
    limit: 10,
    page: isPage + 1,
    gym_id: allFilters.selectedGym?.value || "",
    filter_type:
      cardName === "assigned_members_with_trainer"
        ? "total_assigned_members"
        : cardName === "not_assigned_members"
        ? "total_not_assigned_members"
        : cardName === "biomax_registered_members"
        ? "total_biomax_registered"
        : cardName === "biomax_not_registered_members"
        ? "total_biomax_not_registered"
        : cardName === "pt_trial_pending"
        ? "total_pending_pt_trial"
        : cardName === "pt_trial_completed"
        ? "total_completed_pt_trial"
        : cardName || "",
    last_checkin_days_ago: allFilters.lastCheckedIn?.value || "",
    trainer_id: allFilters.selectedTrainer?.value || "",
    trainer_last_checkin_sort: allFilters.selectedTrainerLastCheckinSorting || "",
  };
  const [filters, setFilters] = useState(iniFilters);

  const onClickReset = () => {
    setAllFilters(iniAllFilters);
    setFilters(iniFilters);
  };

  useEffect(() => {
    setAllFilters((prevs) => ({
      ...prevs,
      selectedGym: prevAllFilters
        ? prevAllFilters.selectedGym
        : !isAdmin
        ? {
            label: isGym ? user?.name : user?.gym_name || "",
            value: user?.gym_id || user?.uid || user?.user_id || "",
          }
        : "",
    }));
  }, [user?.gym_id]);

  useEffect(() => {
    setIsPage(0);
  }, [allFilters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      gym_id: allFilters.selectedGym?.value || "",
      filter_type:
        cardName === "assigned_members_with_trainer"
          ? "total_assigned_members"
          : cardName === "not_assigned_members"
          ? "total_not_assigned_members"
          : cardName === "biomax_registered_members"
          ? "total_biomax_registered"
          : cardName === "biomax_not_registered_members"
          ? "total_biomax_not_registered"
          : cardName === "pt_trial_pending"
          ? "total_pending_pt_trial"
          : cardName === "pt_trial_completed"
          ? "total_completed_pt_trial"
          : cardName || "",
      last_checkin_days_ago: allFilters.lastCheckedIn?.value || "",
      trainer_id: allFilters.selectedTrainer?.value || "",
      trainer_last_checkin_sort:
        allFilters.selectedTrainerLastCheckinSorting || "",
    }));
  }, [
    allFilters.lastCheckedIn,
    allFilters.selectedTrainer,
    allFilters.selectedGym,
    allFilters.selectedTrainerLastCheckinSorting,
    isPage,
  ]);

  return (
    <Container className="bg-cloud-k" fluid>
      <Row>
        <Col>
          <TrainerMemberFilters
            user={user}
            allFilters={allFilters}
            setAllFilters={setAllFilters}
            onClickReset={onClickReset}
            prevGymId={prevAllFilters ? prevAllFilters?.selectedGym?.value : ""}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <TrainerMemberTable
            user={user}
            allFilters={allFilters}
            setAllFilters={setAllFilters}
            filters={filters}
            isPage={isPage}
            setIsPage={setIsPage}
            isGTPTreports={isGTPTreports}
            cardName={cardName}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default TrainerMember;
